export default {
      id: "home-usage",
      viewBox: "0 0 14.417 14.419",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#home",
      toString: function () {
        return this.url;
      }
    }